import { Badge } from '@common/components';
import { cn } from '@core/utils';

interface AdBadgeProps {
  className?: string;
}

export const AdBadge = ({ className }: AdBadgeProps) => {
  return (
    <Badge
      className={cn(
        'absolute right-16 top-16 shrink-0 bg-Gray-black/20 text-Gray-white',
        className,
      )}
    >
      AD
    </Badge>
  );
};
